export default __webpack_public_path__ + "static/media/15.9bc79bf5.png";